export default "__VITE_ASSET__DeRTgmWb__"